import React from 'react'
import * as Displays from 'support/displays'

export function ChecklistActivity () {
  return (
    <div>
      <Displays.Time name='last_activity.filled_at' /> - <Displays.Text name='last_activity.user.name' />
    </div>
  )
}

export default ChecklistActivity
